module.exports = __webpack_public_path__ + "static/img/study_report.898906bf.png";